<template>
  <div>
    <p class="mb-n1">{{ $tc("controller") }}:</p>
    <b-input-group v-if="loading == 0">
      <b-form-select v-model="activity.controller" :disabled="disabled">
        <template slot="first">
          <option v-if="activity.controller" :value="activity.controller">
            {{ activity.controller.fullName }}
          </option>
          <option :value="null">- - {{ $t("unassigned") }} - -</option>
        </template>
        <b-form-select-option v-for="person in possibleResponsible2" :key="person.id" :value="person">
          {{ person.fullName }}
        </b-form-select-option>
      </b-form-select>
      <b-input-group-append>
        <b-button
          cy-id="controller-button"
          variant="default"
          @click="showSearch = !showSearch"
          :disabled="disabled"
        >
          <i
            class="fa"
            :class="{
              'fa-search': !showSearch,
              'fa-search-minus': showSearch
            }"
          />
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <div class="dropdown" v-if="possibleResponsible && showSearch">
      <!-- Dropdown Input -->
      <input class="dropdown-input"
        @focus="showOptions()"
        @blur="exit()"
        @keyup="keyMonitor"
        v-model="searchFilter"
        :disabled="disabled"
        :placeholder="$tc('searchPerson')" />

      <!-- Dropdown Menu -->
      <div class="dropdown-content"
        v-show="optionsShown">
        <div
          class="dropdown-item"
          @mousedown="selectOption(option)"
          v-for="(option, index) in filteredOptions"
          :key="index">
            {{ option.fullName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Protocol } from "@/models/Protocol";
import PersonService from "@/services/PersonService";
import Activity from "@/models/Activity";

  export default {
    name: 'ActivityResponsibleSelector',
    template: 'Dropdown',
    props: {
      editedActivity: {
        type: Activity,
        required: false,
        default: null
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      maxItem: {
        type: Number,
        required: false,
        default: 6,
      },
      adminsOnly: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        activity: this.editedActivity,
        persons: [],
        admins: [],
        optionsShown: false,
        searchFilter: '',
        loading: 0,
        showSearch: false,
      }
    },
    watch: {
      editedActivity(activity) {
        this.activity = activity;
      },
    },
    computed: {
      filteredOptions() {
        const filtered = [];
        const regOption = new RegExp(this.searchFilter, 'ig');
        for (const option of this.possibleResponsible) {
          if (this.searchFilter.length < 1 || option.fullName.match(regOption)){
            if (filtered.length < this.maxItem) filtered.push(option);
          }
        }
        return filtered;
      },
      possibleResponsible() {
        return this.adminsOnly ? this.admins : this.persons;
      },
      possibleResponsible2() {
        return (this.adminsOnly || this.persons.length > 10) ? this.admins : this.persons;
      }
    },
    mounted() {
      this.getPersons();
    },
    methods: {
      getPersons() {
        this.loading++;
        PersonService.getPersonsByCompany(this.$userSelectedCompanyId())
          .then((persons) => {
            this.persons = _.orderBy(persons, ["fullName"], ["asc"]);
            this.admins = this.persons.filter((user) => user.isAdmin);
          })
          .finally(() => {
            this.loading--;
          });
      },
      selectOption(option) {
        this.activity.controller = option;
        this.optionsShown = false;
        this.searchFilter = '';
      },
      showOptions(){
        if (!this.disabled) {
          this.searchFilter = '';
          this.optionsShown = true;
        }
      },
      exit() {
        this.searchFilter = '';
        this.optionsShown = false;
      },
      keyMonitor: function(event) {
        if (event.key === "Enter" && this.filteredOptions[0])
        {
          this.selectOption(this.filteredOptions[0]);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dropdown {
    position: relative;
    display: block;
    margin: auto;
    .dropdown-input {
      background: #fff;
      cursor: pointer;
      border: 1px solid #e7ecf5;
      border-radius: 5px;
      color: #333;
      display: block;
      font-size: .8em;
      padding: 6px;
      &:hover {
        background: #f8f8fa;
      }
    }
    .dropdown-content {
      position: absolute;
      background-color: #fff;
      border: 1px solid #e7ecf5;
      box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);
      overflow: auto;
      z-index: 1;
      .dropdown-item {
        color: black;
        font-size: .7em;
        line-height: 1em;
        padding: 8px;
        text-decoration: none;
        display: block;
        cursor: pointer;
        &:hover {
          background-color: #e7ecf5;
        }
      }
    }
    .dropdown:hover .dropdowncontent {
      display: block;
    }
  }
</style>